var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M24 13.867C24 15.045 22.977 16 21.714 16H2.286C1.023 16 0 15.045 0 13.867V2.133C0 .955 1.023 0 2.286 0h19.428C22.977 0 24 .955 24 2.133v11.734z",
    transform: "translate(-884 -1481) translate(81 1463) translate(803 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.003 5.867L9.795 8.364 8.594 5.867h-1.54v3.587L5.338 5.867h-1.3L2.286 9.59h1.037l.383-.831h1.961l.39.83h1.98V6.826L9.351 9.59h.893l1.343-2.717V9.59h.984V5.867h-1.568zM4.077 7.955l.586-1.302.61 1.302H4.077zm15.856-.268l1.781-1.81h-1.267L19.308 7.03l-1.102-1.163h-3.92V9.59h3.791l1.196-1.232L20.438 9.6h1.263l-1.768-1.913zM17.56 8.809h-2.292v-.737h2.193v-.706h-2.193V6.67l2.42.006.967 1.012-1.095 1.122z",
    transform: "translate(-884 -1481) translate(81 1463) translate(803 18) translate(0 4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.b7bf1ae406fb20e4c2ea09cee60f4502.svg";
export { ForwardRef as ReactComponent };